import { useState } from 'react';
import { CgExport } from 'react-icons/cg';

import { api } from '../../services/api';
import { StatusModal } from '../StatusModal';
import { Button } from './styles';

interface IProps {
  params: any;
  transactionType: string;
  disabled: boolean;
}

export const ExportButton = ({ params, transactionType, disabled }: IProps) => {
  const [modal, setModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState<'success' | 'error'>('success');

  const fetchData = async () => {
    try {
      const endpoint = transactionType === "extrato" ? "export-extract" : "export-transactions";
      const response = await api.post(`transactions/${endpoint}`, {
        data: { ...params, transactionType },
      });
      setModalMessage(response?.data?.message);
      setModal(true);
    } catch (error) {
      setModalType('error');
      setModalMessage('Error ao exportar planilha, tente novamente');
      setModal(true);
    }
  };

  return (
    <>
      <Button onClick={fetchData} disabled={disabled}>
        Exportar
        <CgExport />
      </Button>

      {modal && (
        <StatusModal setModal={setModal} text={modalMessage} type={modalType} />
      )}
    </>
  );
};
